import {$checkboxAll, $checkboxOptions, $filterFormInput} from "./elements";

export function handleCheckAllOptionsClick(e) {
  toggleAllCheckboxes(e);
  setFormInputValue();
}

export function handleCheckOptionClick() {
  checkOrUncheckAllOptionsIfNeeded();
  setFormInputValue();
}

export function setFormInputValue() {
  const selectedFilters =
      [...$checkboxOptions]
          .filter(checkBox => checkBox.checked)
          .map(checkBox => checkBox.value);

  $filterFormInput.val(selectedFilters);
}

export function checkOrUncheckAllOptionsIfNeeded() {
  let checkedOptionsLength = $('.checkboxOptions:checkbox:checked').length;
  let totalCheckboxOptionsLength = $checkboxOptions.length;

  $checkboxAll.prop('checked', checkedOptionsLength === totalCheckboxOptionsLength);
}

function toggleAllCheckboxes(e) {
  const shouldAllCheckboxesBeChecked = e.currentTarget.checked;

  $checkboxOptions.each((index, element) => {
    element.checked = shouldAllCheckboxesBeChecked;
  });
}
